import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllVehicleTypes = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/vehicle-types',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
}

const updateVehicleType = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/vehicle-types/${id}`,
    data: { id: id, ...data },
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
}

const saveVehicleType = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/vehicle-types',
    data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
}

const deleteVehicleType = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/vehicle-types/${id}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
}

export default {
  getAllVehicleTypes,
  saveVehicleType,
  updateVehicleType,
  deleteVehicleType,
}
